<nav class="navbar navbar-expand-md bg-dark text-light justify-content-between sticky-top">
    <ul class="navbar-nav mr-2 ml-2">
        <!-- Page title -->
        <a class="navbar-brand text-light text-weight-bolder hover-logo" (click)="router.navigate(['/'])"><i class="fas fa-project-diagram"></i>
            {{logo}}</a>
    </ul>
</nav>

<div class="d-flex flex-row align-items-center justify-content-center" id="wrap">
    <div id="img404"></div>
</div>
